import React, { useState } from 'react';
import CoauthorNetwork from './faculty_network';

const FacultyProfile = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [selectedYears, setSelectedYears] = useState([
    '2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013'
  ]);
  const [sortBy, setSortBy] = useState('date')

  const publications = [
    {
      id: 1,
      title: 'UGC and JNU: A tale of exceptions told in two acts',
      author: 'Kidwai A.',
      type: 'Book Chapter',
      journal: 'The Idea of a University: Possibilities and Contestations',
      year: 2021,
      pages: '95-103',
    },
    {
      id: 2,
      title: 'Towards inequality',
      author: 'Kidwai A.',
      type: 'Article',
      journal: 'Postcolonial Studies',
      volume: '24',
      year: 2021,
      pages: '33-39',
      isLocked: true,
      doi: '10.1080/13688790.2021.1892805',
    },
    {
      id: 3,
      title: "Life to Indian languages a linguist responds to Javed Majeed's study of grierson's linguistic survey of India",
      author: 'Kidwai A.',
      type: 'Article',
      journal: 'Economic and Political Weekly',
      volume: '55',
      year: 2020,
      pages: '40-48',
    },
    {
      id: 4,
      title: "The People's Linguistic Survey of India Volumes: Neither Linguistics, Nor a Successor to Grierson's LSI, but still a Point of Reference",
      author: 'Kidwai A.',
      type: 'Article',
      journal: 'Social Change',
      volume: '45',
      year: 2019,
      pages: '154-159',
      citations: 3,
      isLocked: true,
    },
  ];



  const handleYearToggle = (year) => {
    setSelectedYears(prevYears =>
      prevYears.includes(year)
        ? prevYears.filter(y => y !== year)
        : [...prevYears, year]
    );
  };

  const sortedPublications = [...publications].sort((a, b) => {
    if (sortBy === 'date') {
      return b.year - a.year;
    }
    return a.title.localeCompare(b.title);
  });

  return (
    <div className="app-body ml-20  h-64 overflow-y-scroll border border-gray-300" id="appBody">

      <div className="flex justify-between items-center mb-6">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md border border-gray-200 ml-4">

          <h1>Vidwan-ID : 40466</h1>
          <button className="px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors mr-4" style={{marginLeft:"138px "}}>
          Edit Profile
        </button>

        </div>
      </div>


      <div className="flex flex-row">

        <div className="space-y-6">

          <div className="flex flex-col items-center pl-4">
            <div className="w-48 h-48 rounded-full border-4 border-gray-200 overflow-hidden">
              <img
                src="https://newprofilepic.photo-cdn.net//assets/images/article/profile.jpg"
                alt="Profile"
                width={192}
                height={192}
                className="w-full h-full object-cover"
              />
            </div>
          </div>


          <nav className="bg-white rounded-lg shadow overflow-hidden pl-4 pr-4 ml-10">
            {[
              { id: 'profile', label: 'Profile', icon: '👤' },
              { id: 'personal', label: 'Personal Information', icon: '📋' },
              { id: 'expertise', label: 'Expertise Information', icon: '🎯' },
              { id: 'experience', label: 'Experience', icon: '💼' },
              { id: 'education', label: 'Education Qualification', icon: '🎓' },
              { id: 'publications', label: 'Publications', icon: '📚' },
            ].map((item) => (
          
            //   <button
            //     key={item.id}
            //     onClick={() => setActiveTab(item.id)}
                
            //     className={`w-full px-4 py-3 text-left flex items-center gap-3 hover:bg-black/50 transition-colors 
            // ${activeTab === item.id ? 'bg-blue-100 font-medium' : ''} m-2`}  // Added mb-2 for spacing between buttons
            //   >
            //     <span>{item.icon}</span>
            //     {item.label}
            //   </button>

            <a
                key={item.id}
                 onClick={() => setActiveTab(item.id)}
                 href={`#${item.id}`}
                
                 className={`w-full px-4 py-3 text-left flex items-center gap-3 hover:bg-black/50 transition-colors 
             ${activeTab === item.id ? 'bg-blue-100 font-medium' : ''} m-2 `}  
             >
             <span>{item.icon}</span>
             {item.label}
            </a>
                
            ))}
          </nav>




          <div className="bg-white rounded-lg shadow p-4 pl-4 ml-10">
            <h3 className="text-lg font-medium mb-4 flex items-center gap-2">
              <span>👥</span> Academic Identity
            </h3>
            <div className="flex items-start gap-3">
              <img
                src="/placeholder.svg"
                alt="Scopus"
                width={40}
                height={40}
                className="w-10 h-10"
              />
              <div>
                <div className="font-medium">Scopus Id</div>
                <div className="text-gray-600">55338952100</div>
              </div>
            </div>
          </div>
        </div>


        <div className="space-y-6">


          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-start gap-4">
              <div className="flex-1">
                <h1 className="text-2xl font-bold text-teal-600 mb-2">Dr Ayesha Kidwai</h1>
                <div className="text-gray-600 flex flex-col gap-1">
                  <div className="flex items-center gap-2">
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 7H4V19H20V7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M16 3H8V7H16V3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    Professor
                  </div>
                  <div className="flex items-center gap-2">
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 21H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M5 21V7L13 3V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M19 21V11L13 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    Jawaharlal Nehru University
                  </div>
                </div>
              </div>
              <div className="w-64">
                <center> <h1 className="text-b font-medium mb-2">Publications 2012 - 2021</h1></center>
                <div className="h-24 flex items-end gap-1">
                  {[2, 4, 3, 1, 1, 1, 1, 2, 3, 4].map((height, i) => (
                    <div
                      key={i}
                      style={{ height: `${height * 20}%` }}
                      className="flex-1 bg-blue-600 rounded-t"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="p-4">
            {/* Publications Section */}
            <div className="border rounded-lg p-4 mb-6">
              <div className="flex items-center gap-2 mb-4">
                <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
                </svg>
                <h2 className="text-lg font-semibold">Publications</h2>
              </div>
              <div className="grid grid-cols-5 gap-4 text-center">
                <div>
                  <div className="text-xl font-bold text-black">3</div>
                  <div className="text-sm text-gray-600">Journal Articles</div>
                </div>
                <div>
                  <div className="text-xl font-bold text-black">1</div>
                  <div className="text-sm text-gray-600">Book Chapter</div>
                </div>
                <div>
                  <div className="text-xl font-bold text-black">3</div>
                  <div className="text-sm text-gray-600">Letter</div>
                </div>
                <div>
                  <div className="text-xl font-bold text-black">3</div>
                  <div className="text-sm text-gray-600">Review</div>
                </div>
                <div>
                  <div className="text-xl font-bold text-black">1</div>
                  <div className="text-sm text-gray-600">Note</div>
                </div>
              </div>
            </div>


            <div className="border rounded-lg p-4 mb-6">
              <h2 className="text-lg font-semibold mb-4">Citations / H-Index</h2>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex items-center gap-4 bg-gray-50 p-4 rounded-lg">
                  <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center text-white text-2xl">
                    "
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-black">5</div>
                    <div className="text-sm text-gray-600">CITATIONS</div>
                  </div>
                </div>
                <div className="flex items-center gap-4 bg-gray-50 p-4 rounded-lg">
                  <div className="w-12 h-12 bg-gray-600 rounded-full flex items-center justify-center text-white text-2xl">
                    H
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-black">1</div>
                    <div className="text-sm text-gray-600">H-INDEX</div>
                  </div>
                </div>
              </div>
            </div>


            <div className="border rounded-lg p-4 mb-6">
              <div className="flex justify-between items-center mb-4">
                <div className="flex items-center gap-2">

                  <h2 className="text-lg font-semibold">Co-author Network</h2>
                </div>
                <button className="bg-teal-600 text-white px-4 py-2 rounded-md">
                  Co-author - 2186
                </button>
              </div>
              <div className="border rounded-lg p-4 mb-6" id="expertise">
                <div className="flex items-center gap-2 mb-4">

                  <h2 className="text-lg font-semibold">Expertise</h2>
                </div>
                <div className="text-sm text-gray-600">
                  Generative Syntax and Morphology, Field Linguistics, The Politics of Language, Translation, Partition Studies
                </div>
              </div>


              <div className="border rounded-lg p-4 mb-6" id="personal">
                <div className="flex items-center gap-2 mb-4">

                  <h2 className="text-lg font-semibold">Personal Information</h2>
                </div>
                <div className="space-y-2">
                  <h3 className="font-medium">Dr Ayesha Kidwai</h3>
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                    Female
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 01-1.581.814L10 13.197l-4.419 3.617A1 1 0 014 16V4z" clipRule="evenodd" />
                    </svg>
                    Jawaharlal Nehru University, New Mehrauli Road
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    New Delhi, Delhi, India - 110067
                  </div>
                </div>
              </div>


              <div className="border rounded-lg p-4 mb-6" id="experience">
                <div className="flex items-center gap-2 mb-4">

                  <h2 className="text-lg font-semibold">Experience</h2>
                </div>
                <div className="flex gap-4">

                  <div>
                    <div className="w-24 text-sm text-gray-600">1995 - Present</div>
                    <div className="font-medium text-gray-600">Professor</div>
                    <div className="text-sm text-gray-600">Centre for Linguistics</div>
                    <div className="text-sm text-gray-600">Jawaharlal Nehru University</div>
                  </div>
                </div>
              </div>

              <div className="border rounded-lg p-4 mb-6" id="education">
              <div className="flex items-center gap-2 mb-4">
               
              <h2 className="text-lg font-semibold">Qualification</h2>

                </div>
                </div>

              <div className="max-w-2xl mx-auto font-sans">
                <div className="flex justify-between items-center py-3">
                  <h2 className="text-sm font-normal text-gray-600 flex items-center gap-1">
                    📚 Publications ({publications.length})
                  </h2>
                  <button
                    onClick={() => setSortBy(sortBy === 'date' ? 'title' : 'date')}
                    className={`px-3 py-1 text-sm border rounded ${sortBy === 'date'
                      ? 'bg-green-500 text-white hover:bg-green-600'
                      : 'bg-blue-500 text-white hover:bg-blue-600'
                      }`}
                  >
                    Sort by {sortBy === 'date' ? 'Title' : 'Date'}
                  </button>

                </div>

                <div className="bg-white border border-gray-300 rounded-lg p-4" id="publications">
                  {sortedPublications.map((pub) => (
                    <div
                      key={pub.id}
                      className="border-b border-gray-200 pb-4 mb-4 last:border-b-0 last:pb-0 last:mb-0"
                    >
                      <a
                        href="#"
                        className="text-blue-600 text-sm font-medium hover:underline block mb-1"
                      >
                        {pub.title}
                      </a>
                      <div className="text-gray-500 text-sm mb-1">{pub.author}</div>
                      <div className="flex items-center gap-2 text-xs flex-wrap">
                        <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full">
                          {pub.type}
                        </span>
                        <span className="text-gray-500">
                          {pub.journal}
                          {pub.volume && `, Volume ${pub.volume}`}
                          {pub.year && `, Year ${pub.year}`}
                          {pub.pages && `, Pages ${pub.pages}`}
                        </span>
                        {pub.doi && (
                          <a
                            href={`https://doi.org/${pub.doi}`}
                            className="text-blue-600 text-xs hover:underline"
                          >
                            DOI: {pub.doi}
                          </a>
                        )}
                      </div>
                      <div className="flex items-center gap-3 mt-2">
                        {pub.citations && (
                          <div className="flex items-center gap-1">
                            <div className="w-6 h-6 bg-blue-600 text-white flex items-center justify-center text-xs rounded-full">
                              {pub.citations}
                            </div>
                            <span className="text-xs text-gray-500">Citations</span>
                          </div>
                        )}
                        {pub.isLocked && (
                          <div className="text-gray-400">
                            🔒
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ height: '100px' }}></div>
              {/* <CoauthorNetwork />  */}
              </div> 
              </div>
        </div>
      </div>
    </div>


  );
};

export default FacultyProfile;